// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { Separator } from '@tectonics/look-and-feel/volcanes/atoms';
import { FieldIndiaUpiId } from '../../../../customer-form/india/field-india-upi-id';
import { UpiIdInfo } from '../../../../payment-method-info/payment-methods/cashfree-upi-collect';

export function EwalletUpiCollectFields(): Node {
  return(
    <>
      <Separator direction="v" size={4} />
      <InputList>
        <FieldIndiaUpiId />
      </InputList>
      <Separator direction="v" size={3} />
      <UpiIdInfo />
      <Separator direction="v" size={2} />
    </>
  );
}

const InputList = styled.div`
  display: grid;
  grid-gap: 2rem;
  grid-template-columns: 1fr 1fr;
  grid-auto-flow: dense;
  & > * {
    grid-column: 1/3;
  }
`;
